import { Map } from 'immutable'

let configurationStore

const configuration = (newConfig) => {
  if (newConfig) {
    configurationStore = Map(newConfig)
  }
  if (!configurationStore) {
    configurationStore = Map()
  }
  return configurationStore
}

export const get = (key, defaultValue) => configuration().get(key, defaultValue)

export const set = (key, value) =>
  (configurationStore = configuration().set(key, value))

export const configure = configuration
